export default __webpack_public_path__ + "static/footer-bg-d3fbecb6f2608f2e1049754310ec614d.png";